module.exports = __webpack_public_path__ + "img/Training.7eead0c6.svg";